import styled from 'styled-components';
import { animated } from 'react-spring';
import { COLORS } from '../../../styles/variables';
import { AlphaTheme } from '../../../../design-system/ThemeProvider/alphaTheme';

export const CTAWrapper = styled.div<{ expanded?: boolean; hasMarginTop?: boolean }>`
  margin-top: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.spaceFixed200 ?? '16px'};
`;

export const ShowAllButton = styled.button`
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.foregroundNeutral200 ?? COLORS.grey60};
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  border: none;
  border-bottom: 1px solid ${COLORS.grey60};
  padding-bottom: 2px;
  cursor: pointer;
  background-color: transparent;
`;

export const ModelFamilyStyleFrame = styled(animated.div)`
  padding: 8px 16px 20px 16px;
`;

export const AllModelsWrapper = styled.div<{ expanded?: boolean; contentHeight?: string }>`
  display: flex;
  flex-direction: column;
  gap: 32px;
  overflow: hidden;
  transition:
    max-height 1s ease,
    opacity 0.5s ease,
    margin-top 1.5s ease;
  margin-top: ${({ expanded }) => (expanded ? '44px' : '0')};
  opacity: ${({ expanded }) => (expanded ? `1` : '0')};
  max-height: ${({ expanded, contentHeight }) => (expanded && contentHeight ? contentHeight : '0')};
`;

export const Legend = styled.div`
  margin-bottom: 12px;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.foregroundNeutral200 ?? COLORS.grey60};
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
`;

export const ActiveOptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  align-items: center;
  cursor: pointer;
`;

export const ActiveListWrapper = styled.div<{ isAlpha?: boolean }>`
  margin-top: 20px;
  display: flex;
  flex-direction: ${({ isAlpha }) => (isAlpha ? 'column' : 'row')};
  flex-wrap: ${({ isAlpha }) => (isAlpha ? 'nowrap' : 'wrap')};
  gap: ${({ isAlpha }) => (isAlpha ? '24px' : '8px')};
`;

export const CancellButton = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: flex;
`;

export const CommonModelsTitle = styled.div<{ hasAnyFilterSelected: boolean }>`
  margin-bottom: 12px;
  margin-top: ${({ hasAnyFilterSelected }) => (hasAnyFilterSelected ? '12px' : '0')};
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.foregroundNeutral200 ?? COLORS.grey60};
  font-family: Audi Type;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
`;

export const CommonModelsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr); /* Two columns, each taking 50% of the width */
  row-gap: 24px;
  padding-bottom: 12px;
`;
